var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContain = function SvgContain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m361.7 382.91-74.57-74.56 21.22-21.22 74.56 74.57v-30.57h30v81.78h-81.78v-30Zm-180.83 0H150.3l74.57-74.56-21.22-21.22-74.56 74.57v-30.57h-30v81.78h81.78ZM129.09 150.3l74.56 74.57 21.22-21.22-74.57-74.56h30.57v-30H99.09v81.78h30Zm179.26 74.57 74.56-74.57v30.57h30V99.09h-81.78v30h30.57l-74.57 74.56ZM478 34v444H34V34zm-30 30H64v384h384Z"
  })));
};
export default SvgContain;